"use client";

import Image from "@components/atoms/Image";
import Button from "@components/atoms/Button";
import assetLoader from "@utils/internalImageLoder";
import { getLoginUrl } from "@utils/getLoginUrl";

interface UnlockButtonProps {
  brandName?: string;
  modelName?: string;
  variantName?: string;
  cityName?: string;
  carAvailability?: string;
  pageType?: string;
}

const UnlockButton = ({
  brandName,
  modelName,
  variantName,
  cityName,
  carAvailability,
  pageType,
}: UnlockButtonProps) => {
  const clickHandler = () => {
    if (typeof window !== "undefined") {
      sessionStorage.setItem("loginType", "Expert rating");
      localStorage.setItem(
        "MMV",
        JSON.stringify({
          make: brandName || "",
          model: modelName || "",
          variant: variantName || "",
        })
      );
      window.location.href = getLoginUrl(window.location.href);
    }
  };

  return (
    <Button
      variant="outline"
      className="unlockButton"
      segmentEventProps={{
        eventName: "action",
        pageType,
        eventProperties: {
          action_type: "tap_btn",
          action_name: "tap_btn_expert_rating",
          car_availability: carAvailability,
          city_name: cityName,
          vehicle_make: brandName,
          vehicle_model: modelName,
          ...(variantName && { vehicle_variant: variantName }),
        },
      }}
      onButtonClick={clickHandler}
    >
      <Image
        src={`${assetLoader()}/icons/UnlockLogo.svg`}
        alt="Unlock icon"
        width={16}
        height={16}
        loading="lazy"
      />
      Unlock expert insights
    </Button>
  );
};

export default UnlockButton;
